<template>
    <div>
        <!-- Si c'est un mineur on affiche la checkbox de l'autorisation parentale -->
        <div v-if="show_autorisation_parentale" class="bordered bg-grey_1 px-2 py-1 mb-3 d-flex align-start">
            <v-checkbox-btn class="checkbox_autorisation_aprentale mb-1" color="primary-dark" hide-details
                v-model="check_autorisation_parentale"> </v-checkbox-btn>
            <div class="mt-2" v-html="content_autorisation_parentale"></div>
        </div>
        <!-- Bouton continuer -->
        <div class="d-flex justify-center">
            <SportipsButton v-if="show_autorisation_parentale && !check_autorisation_parentale" icon="mdi-arrow-down"
                action-button mobile-full-width>
                Passer a l'étape
                suivante
                <v-tooltip activator="parent" location="top">Vous devez confirmer l'autorisation parentale pour ce
                    participant
                    mineur.</v-tooltip>
            </SportipsButton>

            <v-alert v-else-if="only_validated_can_register">
                {{ content_only_validated_can_register }}
            </v-alert>

            <SportipsButton v-else icon="mdi-arrow-down" @onClick="$emit('onContinue')" action-button mobile-full-width>
                Passer a l'étape
                suivante
            </SportipsButton>
        </div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    props: ["inscription"],
    name: 'CheckboxAutorisationParentale',
    data() {
        return {
            isChecked: false,
            check_autorisation_parentale: false,
        };
    },
    computed: {
        ...mapStores(useMainStore),
        is_mineur() {
            return this.inscription.coureur.is_mineur();
        },
        show_autorisation_parentale() {
            const demande_autorisation_parentale = this.mainStore.module.demande_autorisation_parentale;
            return this.is_mineur && demande_autorisation_parentale;
        },
        content_autorisation_parentale() {
            const text_autorisation_parentale = this.mainStore.module.texte_autorisation_parentale;
            if (text_autorisation_parentale) return text_autorisation_parentale;
            return "<p>Inscription mineur: en cliquant sur continuer, je confirme que le mineur a l'autorisation de son représentant légal pour s'inscrire à cet évènement.</p>";
        },
        only_validated_can_register() {
            const only_validated_can_register = this.mainStore.module.only_validated_can_register;
            // Si l'option n'est pas activée, on ne bloque pas
            if (!only_validated_can_register) return false;
            // Si les infos ne sont pas chargé, on ne bloque pas
            if (!this.inscription || !this.inscription.coureur || !this.inscription.coureur.champs || !this.inscription.coureur.champs.type_document) {
                return false;
            }
            let type_document = this.inscription.coureur.champs.type_document.value;
            let coureur_valide = this.inscription.coureur.document_valide;

            // Si le type de document n'est pas renseigné, on bloque
            if (type_document == "Sélectionnez le type de document") {
                return true;
            }

            if ((type_document == "Licence FFA" || type_document == "Pass Prévention Santé") && coureur_valide != '1') {
                return true;
            }
            return false;
        },
        content_only_validated_can_register() {

            if (!this.inscription || !this.inscription.coureur || !this.inscription.coureur.champs || !this.inscription.coureur.champs.type_document) {
                return "";
            }
            let type_document = this.inscription.coureur.champs.type_document.value;
            let coureur_valide = this.inscription.coureur.document_valide;

            if (type_document == "Sélectionnez le type de document") {
                return "Vous devez sélectionner un type de document pour continuer.";
            }
            if (type_document == "Licence FFA" && coureur_valide != '1') {
                return "Nous n'avons pas pu valider la licence de ce coureur via le webservice FFA. Veuillez vérifier les informations saisies.";
            }

            if (type_document == "Pass Prévention Santé" && coureur_valide != '1') {
                return "Nous n'avons pas pu valider le Pass Prévention Santé de ce coureur. Veuillez vérifier les informations saisies.";
            }
            return "";
        },
    }
};
</script>

<style scoped>
/* Add your styles here */
</style>